import Vue from 'vue';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'Budgets',
  components: {
    BudgetComp: require('./budget.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      budgets: [],
      employees: [],
      budgetUsages: [],
      bBudgetDialog: false,
      bConfirmDialog: false,
      deleteConfirmMessage: '',
      editingBudget: {

      },
      editingBudgetClone: {

      },
      message: '',
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.appData.budgetUsages.forEach(p => {
          if (!p.uuid || p.uuid.length === 0)
            p.uuid = uuidv4();
        });
        this.budgets = this.dataObj.appData.budgets;
        this.employees = this.dataObj.appData.employees;
        this.budgetUsages = this.dataObj.appData.budgetUsages;
      });
    },
    addBudget() {
      this.editingBudgetClone = {
        index: 0,
        budgetId: 0,
        employeeId: 0,
        employee: '',
        description: '',
        invoiceNo: '',
        purchaseOrderNo: '',
        requisitionNo: '',
        amount: 0,
        readOnly: false,
        uuid: uuidv4(),
        employees: []
      };
      this.editingBudgetClone.budgets = this.budgets;
      this.editingBudgetClone.employees = this.employees;
      this.bBudgetDialog = true;
    },
    editBudget(item) {
      this.editingBudget = item;
      this.editingBudgetClone = JSON.parse(JSON.stringify(item));
      this.editingBudgetClone.budgets = this.budgets;
      this.editingBudgetClone.employees = this.employees;
      this.bBudgetDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage = this.$t('omApplication.DeleteBudget') + ' [' + item.description + '] ?';
      this.editingBudget = item;
      this.bConfirmDialog = true;
    },
    removeBudget() {
      this.dataObj.appData.budgetUsages = this.dataObj.appData.budgetUsages.filter(p => p.uuid !== this.editingBudget.uuid);
      this.budgetUsages = this.dataObj.appData.budgetUsages;
    },
    saveBudget() {
      this.dataObj.appData.budgetUsages = this.dataObj.appData.budgetUsages.filter(p => p.uuid !== this.editingBudgetClone.uuid);
      delete this.editingBudgetClone.budgets;
      delete this.editingBudgetClone.employees;
      this.editingBudgetClone.amount = parseFloat(this.editingBudgetClone.amount);
      this.dataObj.appData.budgetUsages.push(this.editingBudgetClone);
      this.budgetUsages = this.dataObj.appData.budgetUsages;
      this.bBudgetDialog = false;
    },
    closeDialog() {
      this.bBudgetDialog = false;
    },
  },
  
}

